import styled from 'styled-components'
import { device } from '../../../../styles/GlobalVariables'

export const StyledIcon = styled.svg`
  width: 35px;
  aspect-ratio: 1;
  filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.6));

  ${device.small} {
    width: 40px;
  }

  .st0 {
    fill: #fff;
  }

  .st1 {
    fill-opacity: 0.4;
    fill: #000;
  }
`
